import { environment as devEnv } from './environment.dev'
import { environment as prodEnv } from './environment.prod'
import { IEnv } from './env.type'

const getEnv = (): IEnv => {
  let env = process.env.REACT_APP_STAGE === 'production' ? prodEnv : devEnv
  if (process.env.REACT_APP_API_PREFIX) {
    env.API_PREFIX = process.env.REACT_APP_API_PREFIX
  }

  if (process.env.REACT_APP_SOCKET_PREFIX) {
    env.SOCKET_PREFIX = process.env.REACT_APP_SOCKET_PREFIX
  }

  return env
}

export const environment = getEnv()
